import { call, put, select, takeEvery } from 'redux-saga/effects'
import { sagaPost } from '../../fetch'
import { API_COPY_POLL_URL } from '../../urls'

import { setAlertSuccess } from '../../stores/alert'
import { goToOldLibrary } from '../../stores/routing'
import { intoPollsStore } from '../../stores/pollsStore'

import { getPollsFromLegacyPolls } from '../../legacy'

// SELECTORS
function rootSelector(rootState) {
  return rootState.polls.copyPoll || {}
}

export function getCustomerIds(rootState) {
  return (rootSelector(rootState) || {}).customerIds
}

export function getErrors(rootState) {
  return rootSelector(rootState).errors
}

export function isSaving(rootState) {
  return rootSelector(rootState).isSaving
}

export function getPollName(rootState) {
  return (rootSelector(rootState) || {}).pollName
}

export function isOngoing(rootState) {
  return rootSelector(rootState).poll ? true : false
}

export function* saveCopiedPollSaga() {
  yield takeEvery('POLL/COPY/SAVE_START', saveCopiedPoll)
}

export function* saveCopiedPoll() {
  const pollName = yield select(getPollName)
  const customerIds = yield select(getCustomerIds)

  const ids = customerIds.map(id => {
    let customer = {}
    customer.name = id
    return customer
  })

  const encodedIds = JSON.stringify(ids)

  const requestBody = {
    tool_name: pollName,
    customers: encodedIds,
  }

  // make the call and handle errors
  const response = yield call(sagaPost, API_COPY_POLL_URL, requestBody)

  if (response == null) {
    return yield put(saveErrors(['No response from copy poll']))
  }

  const json = yield call([response, response.json])
  if (!json.created) {
    return yield put(saveErrors(['No polls in response']))
  }
  // Success!
  const polls = getPollsFromLegacyPolls(json.created)
  yield put(intoPollsStore(polls))
  yield put(saveSuccess())
  yield put(goToOldLibrary())
  yield put(setAlertSuccess('Poll successfully created'))
}

// ACTIONS
const POLL_COPY_CLEAR_CUSTOMER_IDS = 'POLL/COPY/CLEAR/CUSTOMER/IDS'
const POLL_COPY_SELECT_ALL_CUSTOMER_IDS = 'POLL/COPY/SELECT/ALL/CUSTOMER/IDS'

export function startCopyPoll(poll) {
  return {
    type: 'POLL/COPY/START',
    payload: {
      poll,
    },
  }
}

export const clearCustomersId = () => ({ type: POLL_COPY_CLEAR_CUSTOMER_IDS })

export const selectAllCustomersId = (customerList: Array) => ({
  type: POLL_COPY_SELECT_ALL_CUSTOMER_IDS,
  payload: { customerList },
})

export const cancelCopyPoll = () => ({ type: 'POLL/COPY/CANCEL' })

export function setName(name) {
  return {
    type: 'POLL/COPY/SET_NAME',
    payload: {
      name,
    },
  }
}

export function setCustomer(customerId) {
  return {
    type: 'POLL/COPY/SET_CUSTOMER',
    payload: {
      customerId,
    },
  }
}

export function removeCustomer(customerId) {
  return {
    type: 'POLL/COPY/REMOVE_CUSTOMER',
    payload: {
      customerId,
    },
  }
}

export function startSave() {
  return {
    type: 'POLL/COPY/SAVE_START',
  }
}

export function saveSuccess(poll) {
  return {
    type: 'POLL/COPY/SAVE_SUCCESS',
    payload: {
      poll,
    },
  }
}

export function saveErrors(errors) {
  return {
    type: 'POLL/COPY/SAVE_ERRORS',
    payload: {
      errors,
    },
  }
}

const Initialstate = {
  customerIds: [],
  pollName: '',
}

// REDUCER
const reducer = (state = Initialstate, { type, payload }) => {
  switch (type) {
    case 'POLL/COPY/START':
      const { poll } = payload
      const pollCopy = {
        ...poll,
      }

      return {
        ...state,
        customerIds: [],
        pollName: poll.name,
        poll: pollCopy,
      }

    case 'POLL/COPY/CANCEL':
      return {
        customerIds: [],
      }

    case 'POLL/COPY/SET_NAME':
      const { name } = payload
      return {
        ...state,
        poll: {
          ...state.poll,
          name,
        },
      }

    case POLL_COPY_CLEAR_CUSTOMER_IDS:
      return {
        ...state,
        customerIds: [],
      }

    case POLL_COPY_SELECT_ALL_CUSTOMER_IDS:
      const { customerList } = payload

      return {
        ...state,
        customerIds: customerList,
      }

    case 'POLL/COPY/SET_CUSTOMER':
      const { customerId } = payload

      return {
        ...state,
        customerIds: state.customerIds.concat([customerId]),
      }

    case 'POLL/COPY/REMOVE_CUSTOMER':
      const { customerId: id } = payload

      return {
        ...state,
        customerIds: state.customerIds.filter(customerId => customerId !== id),
      }

    case 'POLL/COPY/SAVE_START':
      return {
        ...state,
        isSaving: true,
        errors: null,
      }

    case 'POLL/COPY/SAVE_SUCCESS':
      return {}

    case 'POLL/COPY/SAVE_ERRORS':
      const { errors } = payload
      return {
        ...state,
        errors,
        isSaving: false,
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/stores/polls/copyPoll.js